module.exports = __webpack_public_path__ + "static/google_cloud-7ea5e2196ee2da9b51a8a59d4b38fd68.svg";